import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import { VARIANTS } from '../../../constants/variants.js';
import modules_9b3c4676 from '../styles/Card.module.less.js';

/**
 * @description Simple rectangular container
 *
 * @component
 * @example
 * ```jsx
 * <Card>content</Card>
 * ```
 */
const Card = React.forwardRef((props, ref) => {
    const { variant, size, color, shadow, className, children, ...restProps } = props;
    const cx = useStyles(modules_9b3c4676);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
        [`color-${color}-${variant}`]: true,
        shadow,
    });
    return (React.createElement("div", { ref: ref, "data-qa": "Card", className: classNames, ...restProps }, children));
});
Card.defaultProps = {
    size: 24,
    color: COLORS.LIGHT,
    variant: VARIANTS.SECONDARY,
    shadow: false,
};
Card.displayName = 'Card';

export { Card };
//# sourceMappingURL=Card.js.map
